// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
const businessCollectionActionTypes = {
	/************************ GET SEARCH BUSINESS LOAN LIST START ****************** */
	GET_SEARCH_BUSINESS_LOAN_LIST_START: 'get_search_business_loan_list_start',
	GET_SEARCH_BUSINESS_LOAN_LIST_SUCCESS: 'get_search_business_loan_list_success',
	GET_SEARCH_BUSINESS_LOAN_LIST_FAILURE: 'get_search_business_loan_list_failure',
	GET_SEARCH_BUSINESS_LOAN_LIST_RESPONSE_RESET: 'get_search_business_loan_list_response_reset',
	GET_SEARCH_BUSINESS_LOAN_LIST_RESPONSE_CHANGED:
		'get_search_business_loan_list_response_changed',
	/************************ GET SEARCH BUSINESS LOAN LIST END ****************** */

	/************************ GET SEARCH BUSINESS LOAN INFO START ****************** */
	GET_BUSINESS_LOAN_INFO_START: 'get_business_loan_info_start',
	GET_BUSINESS_LOAN_INFO_SUCCESS: 'get_business_loan_info_success',
	GET_BUSINESS_LOAN_INFO_FAILURE: 'get_business_loan_info_failure',
	GET_BUSINESS_LOAN_INFO_RESPONSE_RESET: 'get_business_loan_info_response_reset',
	GET_BUSINESS_LOAN_INFO_RESPONSE_CHANGED: 'get_business_loan_info_response_changed',
	/************************ GET SEARCH BUSINESS LOAN INFO END ****************** */

	/************************ UPDATE BUSINESS COLLECTION START ****************** */
	UPDATE_BUSINESS_COLLECTION_START: 'update_business_collection_start',
	UPDATE_BUSINESS_COLLECTION_SUCCESS: 'update_business_collection_success',
	UPDATE_BUSINESS_COLLECTION_FAILURE: 'update_business_collection_failure',
	UPDATE_BUSINESS_COLLECTION_RESPONSE_RESET: 'update_business_collection_reponse_start',
	UPDATE_BUSINESS_COLLECTION_RESPONSE_CHANGED: 'update_business_collection_reponse_changed',
	/************************ UPDATE BUSINESS COLLECTION END ****************** */

	/************************ UPDATE BUSINESS DEATH START ****************** */
	UPDATE_BUSINESS_DEATH_START: 'update_business_death_start',
	UPDATE_BUSINESS_DEATH_SUCCESS: 'update_business_death_success',
	UPDATE_BUSINESS_DEATH_FAILURE: 'update_business_death_failure',
	UPDATE_BUSINESS_DEATH_RESPONSE_RESET: 'update_business_death_response_reset',
	UPDATE_BUSINESS_DEATH_RESPONSE_CHANGED: 'update_business_death_reponse_changed',
	/************************ UPDATE BUSINESS DEATH START ****************** */

	/************************ UPDATE INTEREST WAIVER START****************** */
	UPDATE_BUSINESS_INTEREST_WAIVER_START: 'update_business_interest_waiver_start',
	UPDATE_BUSINESS_INTEREST_WAIVER_SUCCESS: 'update_business_interest_waiver_success',
	UPDATE_BUSINESS_INTEREST_WAIVER_FAILURE: 'update_business_interest_waiver_failure',
	UPDATE_BUSINESS_INTEREST_WAIVER_RESPONSE_RESET:
		'update_business_interest_waiver_response_reset',
	UPDATE_BUSINESS_INTEREST_WAIVER_RESPONSE_CHANGED:
		'update_business_interest_waiver_response_changed',
	/************************ UPDATE INTEREST WAIVER END****************** */

	/************************ GET BUSINESS COLLECTION START ****************** */
	GET_BUSINESS_COLLECTION_START: 'get_business_collection_start',
	GET_BUSINESS_COLLECTION_SUCCESS: 'get_business_collection_success',
	GET_BUSINESS_COLLECTION_FAILURE: 'get_business_collection_failure',
	GET_BUSINESS_COLLECTION_RESPONSE_RESET: 'get_business_collection_response_reset',
	GET_BUSINESS_COLLECTION_RESPONSE_CHANGED: 'get_business_collection_response_changed',
	/************************ GET BUSINESS COLLECTION END ****************** */

	/************************ GET BUSINESS WALLET START ****************** */
	GET_BUSINESS_WALLET_START: 'get_business_wallet_start',
	GET_BUSINESS_WALLET_SUCCESS: 'get_business_wallet_success',
	GET_BUSINESS_WALLET_FAILURE: 'get_business_wallet_failure',
	GET_BUSINESS_WALLET_RESPONSE_RESET: 'get_business_wallet_response_reset',
	GET_BUSINESS_WALLET_RESPONSE_CHANGED: 'get_business_wallet_response_changed',
	/************************ GET BUSINESS WALLET END ****************** */

	/************************ ADD BUSINESS WALLET START ****************** */
	ADD_BUSINESS_WALLET_START: 'add_business_wallet_start',
	ADD_BUSINESS_WALLET_SUCCESS: 'add_business_wallet_success',
	ADD_BUSINESS_WALLET_FAILURE: 'add_business_wallet_failure',
	ADD_BUSINESS_WALLET_RESPONSE_RESET: 'add_business_wallet_reset',
	ADD_BUSINESS_WALLET_RESPONSE_CHANGED: 'add_business_wallet_change',
	/************************ ADD BUSINESS WALLET END ****************** */

	/************************ GET BUSINESS QR START ****************** */
	GET_BUSINESS_QR_START: 'get_business_qr_start',
	GET_BUSINESS_QR_SUCCESS: 'get_business_qr_success',
	GET_BUSINESS_QR_FAILURE: 'get_business_qr_failure',
	GET_BUSINESS_QR_RESPONSE_RESET: 'get_business_qr_response_reset',
	GET_BUSINESS_QR_RESPONSE_CHANGED: 'get_business_qr_response_changed',
	/************************ GET BUSINESS QR END ****************** */

	/************************ GET BUSINESS REPAYMENT START****************** */
	GET_BUSINESS_REPAYMENT_START: 'get_business_repayment_start',
	GET_BUSINESS_REPAYMENT_SUCCESS: 'get_business_repayment_success',
	GET_BUSINESS_REPAYMENT_FAILURE: 'get_business_repayment_failure',
	GET_BUSINESS_REPAYMENT_RESPONSE_RESET: 'get_business_repayment_response_reset',
	GET_BUSINESS_REPAYMENT_RESPONSE_CHANGED: 'get_business_repayment_response_changed',
	/************************ GET BUSINESS REPAYMENT END ****************** */

	/************************ DELETE BUSINESS WALLET START ****************** */
	DELETE_BUSINESS_WALLET_START: 'delete_business_wallet_start',
	DELETE_BUSINESS_WALLET_SUCCESS: 'delete_business_wallet_success',
	DELETE_BUSINESS_WALLET_FAILURE: 'delete_business_wallet_failure',
	DELETE_BUSINESS_WALLET_RESPONSE_RESET: 'delete_business_wallet_response_reset',
	DELETE_BUSINESS_WALLET_RESPONSE_CHANGED: 'delete_business_wallet_response_changed',
	/************************ DELETE BUSINESS WALLET END ****************** */

	/************************ REVERT BUSINESS COLLECTION START ****************** */
	REVERT_BUSINESS_COLLECTION_START: 'revert_business_collection_start',
	REVERT_BUSINESS_COLLECTION_SUCCESS: 'revert_business_collection_success',
	REVERT_BUSINESS_COLLECTION_FAILURE: 'revert_business_collection_failure',
	REVERT_BUSINESS_COLLECTION_RESPONSE_RESET: 'revert_business_collection_response_reset',
	REVERT_BUSINESS_COLLECTION_RESPONSE_CHANGED: 'revert_business_collection_response_changed',
	/************************ REVERT BUSINESS COLLECTION END ****************** */

	/************************ BUSINESS LOAN CARD PDF DEATAILS START ****************** */
	BUSINESS_LOAN_CARD_PDF_START: 'business_loan_card_pdf_start',
	BUSINESS_LOAN_CARD_PDF_SUCCESS: 'business_loan_card_pdf_success',
	BUSINESS_LOAN_CARD_PDF_FAILURE: 'business_loan_card_pdf_failure',
	BUSINESS_LOAN_CARD_PDF_RESPONSE_RESET: 'business_loan_card_pdf_response_reset',
	BUSINESS_LOAN_CARD_PDF_RESPONSE_CHANGED: 'business_loan_card_pdf_response_changed',
	/************************ BUSINESS LOAN CARD DEATAILS END ****************** */

	/************************ BUSINESS REPAYMENT PDF DEATAILS START ****************** */
	BUSINESS_REPAYMENT_PDF_START: 'business_repayment_pdf_start',
	BUSINESS_REPAYMENT_PDF_SUCCESS: 'business_repayment_pdf_success',
	BUSINESS_REPAYMENT_PDF_FAILURE: 'business_repayment_pdf_failure',
	BUSINESS_REPAYMENT_PDF_RESPONSE_RESET: 'business_repayment_pdf_response_reset',
	BUSINESS_REPAYMENT_PDF_RESPONSE_CHANGED: 'business_repayment_pdf_response_changed',
	/************************ BUSINESS REPAYMENT DEATAILS END ****************** */

	/************************ BUSINESS LOAN CARD REPORT START ****************** */
	BUSINESS_LOAN_CARD_REPORT_START: 'business_loan_card_report_start',
	BUSINESS_LOAN_CARD_REPORT_SUCCESS: 'business_loan_card_report_success',
	BUSINESS_LOAN_CARD_REPORT_FAILURE: 'business_loan_card_report_failure',
	BUSINESS_LOAN_CARD_REPORT_RESPONSE_RESET: 'business_loan_card_report_response_reset',
	BUSINESS_LOAN_CARD_REPORT_RESPONSE_CHANGED: 'business_loan_card_report_response_changed',
	/************************ BUSINESS LOAN CARD REPORT END ****************** */

	/************************ BUSINESS LOAN COLLECTION APPROVAL START ****************** */
	BUSINESS_LOAN_COLLECTION_APPROVAL_START: 'business_loan_collection_approval_start',
	BUSINESS_LOAN_COLLECTION_APPROVAL_SUCCESS: 'business_loan_collection_approval_success',
	BUSINESS_LOAN_COLLECTION_APPROVAL_FAILURE: 'business_loan_collection_approval_failure',
	BUSINESS_LOAN_COLLECTION_APPROVAL_RESPONSE_RESET:
		'business_loan_collection_approval_response_reset',
	BUSINESS_LOAN_COLLECTION_APPROVAL_RESPONSE_CHANGED:
		'business_loan_collection_approval_response_changed',
	/************************ BUSINESS LOAN COLLECTION APPROVAL END ****************** */

	/************************ BUSINESS LOAN COLLECTION LOAN PAID START ****************** */
	BUSINESS_COLLECTION_LOAN_PAID_ENTRY_START: 'business_collection_loan_paid_entry_start',
	BUSINESS_COLLECTION_LOAN_PAID_ENTRY_SUCCESS: 'business_collection_loan_paid_entry_success',
	BUSINESS_COLLECTION_LOAN_PAID_ENTRY_FAILURE: 'business_collection_loan_paid_entry_failure',
	BUSINESS_COLLECTION_LOAN_PAID_ENTRY_REPONSE_RESET:
		'business_collection_loan_paid_entry_response_reset',
	BUSINESS_COLLECTION_LOAN_PAID_ENTRY_RESPONSE_CHANGED:
		'business_collection_loan_paid_entry_response_changed',
	/************************ BUSINESS LOAN COLLECTION LOAN PAID END ****************** */

	/************************ BUSINESS LOAN COLLECTION LOAN PAID ARREAR START ****************** */
	BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_START:
		'business_collection_loan_paid_arrear_entry_start',
	BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_SUCCESS:
		'business_collection_loan_paid_arrear_entry_success',
	BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_FAILURE:
		'business_collection_loan_paid_arrear_entry_failure',
	BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_REPONSE_RESET:
		'business_collection_loan_paid_arrear_entry_response_reset',
	BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_RESPONSE_CHANGED:
		'business_collection_loan_paid_arrear_entry_response_changed',
	/************************ BUSINESS LOAN COLLECTION LOAN PAID ARREAR END ****************** */

};
export default businessCollectionActionTypes;
